import React from "react"
import PlaceList from "./PlaceList"
import { useStaticQuery, graphql } from "gatsby"

const getPlaces = graphql`
query {
    places: allContentfulFeaturedRehab {
        edges {
            node {
                featured
                name
                slug
                contentful_id
                images {
                    fluid {
                        ...GatsbyContentfulFluid
                }
            }
        }
    }
}
}
`
const Places = () => {
    const { places } = useStaticQuery(getPlaces)
    return <PlaceList places={places} />
}

export default Places
